import { render } from "./SessionImageViewer.vue?vue&type=template&id=25a9adc2&ts=true"
import script from "./SessionImageViewer.vue?vue&type=script&lang=ts"
export * from "./SessionImageViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__